import { createApp, h } from 'vue'
import router from './router'
import App from './App.vue'
import axios from 'axios'
import moment from 'moment-timezone'
import lodash from 'lodash'
import {
  plugin as formKitPlugin,
  defaultConfig as formKitDefaultConfig,
} from '@formkit/vue'
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'

const formKitConfig = formKitDefaultConfig({})

const oktaAuth = new OktaAuth({
  issuer: process.env.VUE_APP_OKTA_ISSUER,
  clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
  redirectUri: process.env.VUE_APP_OKTA_REDIRECT_URL,
  scopes: ['openid', 'profile', 'email'],
})

// global components
import Placeholder from './components/Placeholder.vue'
import LocalTime from './components/LocalTime.vue'
import Severity from './components/Severity.vue'
import Status from './components/Status.vue'
import Type from './components/Type.vue'

const app = createApp({ render: () => h(App) })

app.component('Placeholder', Placeholder)
app.component('LocalTime', LocalTime)
app.component('Severity', Severity)
app.component('Status', Status)
app.component('Type', Type)

app.config.productionTip = false

// include styles
import './scss/custom.scss'

var jiraExtLinks = []
jiraExtLinks['moonpig'] = 'https://greetz.atlassian.net'
jiraExtLinks['greetz'] = 'https://greetz.atlassian.net'

var tz = []
tz['moonpig'] = 'Europe/London'
tz['greetz'] = 'Europe/Amsterdam'

app.config.globalProperties.$api = axios
app.config.globalProperties.$moment = moment
app.config.globalProperties.$lodash = lodash
app.config.globalProperties.$timezones = tz
app.config.globalProperties.$urls = {
  slack: process.env.VUE_APP_SLACK_URL,
  jira: process.env.VUE_APP_INCIDENTS_API,
  jiraExternal: jiraExtLinks,
}

app.use(OktaVue, { oktaAuth })
app.use(formKitPlugin, formKitConfig)
app.use(router)
app.mount('#app')
